.player-button {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: var(--player-base-z-index);
  margin-bottom: 8vw;
  margin-right: 2vw;
  opacity: 0;

  &.visible {
    opacity: 1;
    transition: opacity 200ms ease-in-out;
  }
}
